<template>
    <div class="basic-actions">
        <div class="scopes-table">
            <div class="scopes-table-header">
                <div
                    v-for="column in columns"
                    class="scopes-table-header-item"
                    :class="{ [column.headerClassNames]: true }"
                    :key="column.id"
                    :style="{
                        flex: column.flex,
                        width: column.width ? column.width + 'px' : 'auto',
                        'max-width': column.maxWidth ? column.maxWidth + 'px' : 'auto',
                    }"
                >
                    <template>{{ column.title }}</template>
                </div>
            </div>
            <div class="scopes-table-body">
                <div class="row" v-for="row in rows" :key="row.id">
                    <div
                        class="cell"
                        v-for="column in columns"
                        :key="column.id"
                        :style="{
                            flex: column.flex,
                            width: column.width ? column.width + 'px' : 'auto',
                            'max-width': column.maxWidth ? column.maxWidth + 'px' : 'auto',
                        }"
                        :class="{ [column.rowClassNames]: true }"
                        @click="toggleActive(row.id, column.slot)"
                    >
                        <template v-if="column.slot === 'web'">
                            <SupsisButton>
                                <i
                                    class="material-icons spin-effect"
                                    v-if="loading && loading.item == row.id && loading.platform == 'web'"
                                    >sync</i
                                >
                                <i class="material-icons text-success" v-else-if="isActive(row.id, 'web')">done</i>
                                <div
                                    class="disabled-item"
                                    @mouseenter="hoverEffect($event, true)"
                                    @mouseleave="hoverEffect($event, false)"
                                    v-else
                                >
                                    <i class="material-icons">done</i>
                                    <i class="material-icons">circle</i>
                                </div>
                            </SupsisButton>
                        </template>
                        <template v-else-if="column.slot === 'mobile'">
                            <SupsisButton>
                                <i
                                    class="material-icons spin-effect"
                                    v-if="loading && loading.item == row.id && loading.platform == 'mobile'"
                                    >sync</i
                                >
                                <i class="material-icons text-success" v-else-if="isActive(row.id, 'mobile')">done</i>
                                <div
                                    class="disabled-item"
                                    @mouseenter="hoverEffect($event, true)"
                                    @mouseleave="hoverEffect($event, false)"
                                    v-else
                                >
                                    <i class="material-icons">done</i>
                                    <i class="material-icons">circle</i>
                                </div>
                            </SupsisButton>
                        </template>
                        <template v-else-if="column.slot === 'email'">
                            <SupsisButton>
                                <i
                                    class="material-icons spin-effect"
                                    v-if="loading && loading.item == row.id && loading.platform == 'email'"
                                    >sync</i
                                >
                                <i class="material-icons text-success" v-else-if="isActive(row.id, 'email')">done</i>
                                <div
                                    class="disabled-item"
                                    @mouseenter="hoverEffect($event, true)"
                                    @mouseleave="hoverEffect($event, false)"
                                    v-else
                                >
                                    <i class="material-icons">done</i>
                                    <i class="material-icons">circle</i>
                                </div>
                            </SupsisButton>
                        </template>
                        <template v-else>
                            <div class="first-cell">
                                <!--                                <i class="material-icons" v-if="row.id === 'chat-assign'">3p</i>-->
                                <!--                                <i class="material-icons" v-else-if="row.id === 'ticket-assign'"-->
                                <!--                                    >assignment_turned_in</i-->
                                <!--                                >-->
                                <!--                                <i class="material-icons" v-else-if="row.id === 'task-assign'">add_task</i>-->
                                <!--                                <i class="material-icons" v-else-if="row.id === 'chat-close-own'">mark_chat_read</i>-->
                                <i class="material-icons" v-if="row.icon">{{ row.icon }}</i>
                                {{ row[column.id] }}
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import SupsisButton from "../../components/SupsisButton.vue";
import { ACTIVITY_API } from "../../../../../api/activity";

export default Vue.extend({
    name: "BasicActions",
    components: { SupsisButton },
    props: {
        settings: {
            type: Array,
            required: true,
        },
        title: {
            type: String,
            default: "Basic Actions",
        },
        allowedScopes: {
            type: Array,
            default: () => ["chat-assign", "ticket-assign", "task-assign", "chat-close-own", "contact-owner"],
        },
    },
    data() {
        return {
            loading: null,
            scopeId: false,
        };
    },
    computed: {
        columns() {
            return [
                {
                    id: "label",
                    title: this.title,
                    flex: 5,
                    rowClassNames: "",
                    headerClassNames: "",
                },
                {
                    id: "web",
                    title: this.$t("notification.webPanel"),
                    flex: 1,
                    slot: "web",
                    rowClassNames: "checkbox-cell",
                    headerClassNames: "center",
                },
                {
                    id: "mobile",
                    title: this.$t("notification.mobileApp"),
                    flex: 1,
                    rowClassNames: "checkbox-cell",
                    slot: "mobile",
                    headerClassNames: "center",
                },
                {
                    id: "email",
                    title: this.$t("ticimax.attributes.email"),
                    flex: 1,
                    rowClassNames: "checkbox-cell",
                    slot: "email",
                    headerClassNames: "center",
                },
            ];
        },
        rows() {
            return [
                {
                    id: "chat-assign",
                    label: this.$t("notification.chatAssignedMe"),
                    web: this.isActive("chat-assign", "web"),
                    email: this.isActive("chat-assign", "email"),
                    mobile: this.isActive("chat-assign", "mobile"),
                    icon: "3p",
                },
                {
                    id: "ticket-assign",
                    label: this.$t("notification.ticketAssignedMe"),
                    web: this.isActive("ticket-assign", "web"),
                    email: this.isActive("ticket-assign", "email"),
                    mobile: this.isActive("ticket-assign", "mobile"),
                    icon: "assignment_turned_in",
                },
                {
                    id: "task-assign",
                    label: this.$t("notification.taskAssignedMe"),
                    web: this.isActive("task-assign", "web"),
                    email: this.isActive("task-assign", "email"),
                    mobile: this.isActive("task-assign", "mobile"),
                    icon: "add_task",
                },
                {
                    id: "task-complet",
                    label: this.$t("notification.taskComplet"),
                    web: this.isActive("task-complete", "web"),
                    email: this.isActive("task-complete", "email"),
                    mobile: this.isActive("task-complete", "mobile"),
                    icon: "check_circle",
                },
                {
                    id: "task-archive",
                    label: this.$t("notification.taskArchive"),
                    web: this.isActive("task-archive", "web"),
                    email: this.isActive("task-archive", "email"),
                    mobile: this.isActive("task-archive", "mobile"),
                    icon: "archive",
                },
                {
                    id: "chat-close-own",
                    label: this.$t("notification.myChatClosed"),
                    web: this.isActive("chat-close-own", "web"),
                    email: this.isActive("chat-close-own", "email"),
                    mobile: this.isActive("chat-close-own", "mobile"),
                    icon: "mark_chat_read",
                },
                {
                    id: "contact-owner",
                    label: this.$t("notification.contactOwner"),
                    web: this.isActive("contact-owner", "web"),
                    email: this.isActive("contact-owner", "email"),
                    mobile: this.isActive("contact-owner", "mobile"),
                    icon: "3p",
                },
                {
                    id: "tag-actions-to-visitor",
                    label: this.$t("notification.tagActionsToVisitor"),
                    web: this.isActive("tag-actions-to-visitor", "web"),
                    email: this.isActive("tag-actions-to-visitor", "email"),
                    mobile: this.isActive("tag-actions-to-visitor", "mobile"),
                    icon: "bookmark",
                },
                {
                    id: "create-ticket",
                    label: this.$t("notification.ticketCreated"),
                    web: this.isActive("create-ticket", "web"),
                    email: this.isActive("create-ticket", "email"),
                    mobile: this.isActive("create-ticket", "mobile"),
                    icon: "confirmation_number",
                },
                {
                    id: "note-actions-to-visitor",
                    label: this.$t("notification.notesActions"),
                    web: this.isActive("note-actions-to-visitor", "web"),
                    email: this.isActive("note-actions-to-visitor", "email"),
                    mobile: this.isActive("note-actions-to-visitor", "mobile"),
                    icon: "sticky_note_2",
                },
                {
                    id: "visitor-profile-updates",
                    label: this.$t("notification.visitorProfileUpdated"),
                    web: this.isActive("visitor-profile-updates", "web"),
                    email: this.isActive("visitor-profile-updates", "email"),
                    mobile: this.isActive("visitor-profile-updates", "mobile"),
                    icon: "account_box",
                },
                {
                    id: "chat-start",
                    label: this.$t("notification.chatStartedByAnyPlatform"),
                    web: this.isActive("chat-start", "web"),
                    email: this.isActive("chat-start", "email"),
                    mobile: this.isActive("chat-start", "mobile"),
                    icon: "chat",
                },
                {
                    id: "user-crud",
                    label: this.$t("notification.userActions"),
                    web: this.isActive("user-crud", "web"),
                    email: this.isActive("user-crud", "email"),
                    mobile: this.isActive("user-crud", "mobile"),
                    icon: "person_add",
                },
                {
                    id: "department-crud",
                    label: this.$t("notification.departmentActions"),
                    web: this.isActive("department-crud", "web"),
                    email: this.isActive("department-crud", "email"),
                    mobile: this.isActive("department-crud", "mobile"),
                    icon: "domain_add",
                },
                {
                    id: "settings-crud",
                    label: this.$t("notification.settingsActions"),
                    web: this.isActive("settings-crud", "web"),
                    email: this.isActive("settings-crud", "email"),
                    mobile: this.isActive("settings-crud", "mobile"),
                    icon: "settings",
                },
                {
                    id: "integration-channel-crud",
                    label: this.$t("notification.integrationsActions"),
                    web: this.isActive("integration-channel-crud", "web"),
                    email: this.isActive("integration-channel-crud", "email"),
                    mobile: this.isActive("integration-channel-crud", "mobile"),
                    icon: "integration_instructions",
                },
                {
                    id: "login-form-crud",
                    label: this.$t("notification.loginFormActions"),
                    web: this.isActive("login-form-crud", "web"),
                    email: this.isActive("login-form-crud", "email"),
                    mobile: this.isActive("login-form-crud", "mobile"),
                    icon: "assignment",
                },
                {
                    id: "banned-word-crud",
                    label: this.$t("notification.bannedWordActions"),
                    web: this.isActive("banned-word-crud", "web"),
                    email: this.isActive("banned-word-crud", "email"),
                    mobile: this.isActive("banned-word-crud", "mobile"),
                    icon: "block",
                },
                {
                    id: "email-account-crud",
                    label: this.$t("notification.emailActions"),
                    web: this.isActive("email-account-crud", "web"),
                    email: this.isActive("email-account-crud", "email"),
                    mobile: this.isActive("email-account-crud", "mobile"),
                    icon: "contact_mail",
                },
                {
                    id: "prepared-content-crud",
                    label: this.$t("notification.preparedContentActions"),
                    web: this.isActive("prepared-content-crud", "web"),
                    email: this.isActive("prepared-content-crud", "email"),
                    mobile: this.isActive("prepared-content-crud", "mobile"),
                    icon: "content_copy",
                },
                {
                    id: "role-crud",
                    label: this.$t("notification.roleActions"),
                    web: this.isActive("role-crud", "web"),
                    email: this.isActive("role-crud", "email"),
                    mobile: this.isActive("role-crud", "mobile"),
                    icon: "admin_panel_settings",
                },
                {
                    id: "tag-crud",
                    label: this.$t("notification.tagActions"),
                    web: this.isActive("tag-crud", "web"),
                    email: this.isActive("tag-crud", "email"),
                    mobile: this.isActive("tag-crud", "mobile"),
                    icon: "bookmark",
                },
                {
                    id: "welcome-message-crud",
                    label: this.$t("notification.welcomeMessageActions"),
                    web: this.isActive("welcome-message-crud", "web"),
                    email: this.isActive("welcome-message-crud", "email"),
                    mobile: this.isActive("welcome-message-crud", "mobile"),
                    icon: "message",
                },
                {
                    id: "webhook-crud",
                    label: this.$t("notification.webhookActions"),
                    web: this.isActive("webhook-crud", "web"),
                    email: this.isActive("webhook-crud", "email"),
                    mobile: this.isActive("webhook-crud", "mobile"),
                    icon: "webhook",
                },
                {
                    id: "billing-events",
                    label: this.$t("notification.billingEvents"),
                    web: this.isActive("billing-events", "web"),
                    email: this.isActive("billing-events", "email"),
                    mobile: this.isActive("billing-events", "mobile"),
                    icon: "receipt_long",
                },
                {
                    id: "task-workflow-created",
                    label: this.$t("notification.workflowCreated"),
                    web: this.isActive("task-workflow-created", "web"),
                    email: this.isActive("task-workflow-created", "email"),
                    mobile: this.isActive("task-workflow-created", "mobile"),
                    icon: "add_circle",
                },
                {
                    id: "task-workflow-updated",
                    label: this.$t("notification.taskWorkflowUpdatedNotification"),
                    web: this.isActive("task-workflow-updated", "web"),
                    email: this.isActive("task-workflow-updated", "email"),
                    mobile: this.isActive("task-workflow-updated", "mobile"),
                    icon: "account_tree",
                },
                {
                    id: "task-workflow-permanently-deleted",
                    label: this.$t("notification.taskWorkflowPermanentlyDeletedNotification"),
                    web: this.isActive("task-workflow-permanently-deleted", "web"),
                    email: this.isActive("task-workflow-permanently-deleted", "email"),
                    mobile: this.isActive("task-workflow-permanently-deleted", "mobile"),
                    icon: "delete_forever",
                },
                {
                    id: "task-workflow-pipeline-stage-added",
                    label: this.$t("notification.taskWorkflowPipelineStageAddedNotification"),
                    web: this.isActive("task-workflow-pipeline-stage-added", "web"),
                    email: this.isActive("task-workflow-pipeline-stage-added", "email"),
                    mobile: this.isActive("task-workflow-pipeline-stage-added", "mobile"),
                    icon: "add_box",
                },
                {
                    id: "task-workflow-pipeline-stage-updated",
                    label: this.$t("notification.taskWorkflowPipelineStageUpdatedNotification"),
                    web: this.isActive("task-workflow-pipeline-stage-updated", "web"),
                    email: this.isActive("task-workflow-pipeline-stage-updated", "email"),
                    mobile: this.isActive("task-workflow-pipeline-stage-updated", "mobile"),
                    icon: "edit",
                },
                {
                    id: "task-workflow-pipeline-stage-deleted",
                    label: this.$t("notification.taskWorkflowPipelineStageDeletedNotification"),
                    web: this.isActive("task-workflow-pipeline-stage-deleted", "web"),
                    email: this.isActive("task-workflow-pipeline-stage-deleted", "email"),
                    mobile: this.isActive("task-workflow-pipeline-stage-deleted", "mobile"),
                    icon: "delete",
                },
                {
                    id: "task-module-rules-enabled",
                    label: this.$t("notification.taskModuleRulesEnabledNotification"),
                    web: this.isActive("task-module-rules-enabled", "web"),
                    email: this.isActive("task-module-rules-enabled", "email"),
                    mobile: this.isActive("task-module-rules-enabled", "mobile"),
                    icon: "rule",
                },
                {
                    id: "task-module-rules-disabled",
                    label: this.$t("notification.taskModuleRulesDisabledNotification"),
                    web: this.isActive("task-module-rules-disabled", "web"),
                    email: this.isActive("task-module-rules-disabled", "email"),
                    mobile: this.isActive("task-module-rules-disabled", "mobile"),
                    icon: "rule",
                },
                {
                    id: "task-module-rules-rule-added",
                    label: this.$t("notification.taskModuleRulesRuleAddedNotification"),
                    web: this.isActive("task-module-rules-rule-added", "web"),
                    email: this.isActive("task-module-rules-rule-added", "email"),
                    mobile: this.isActive("task-module-rules-rule-added", "mobile"),
                    icon: "add_circle",
                },
                {
                    id: "task-module-rules-rule-deleted",
                    label: this.$t("notification.taskModuleRulesRuleDeletedNotification"),
                    web: this.isActive("task-module-rules-rule-deleted", "web"),
                    email: this.isActive("task-module-rules-rule-deleted", "email"),
                    mobile: this.isActive("task-module-rules-rule-deleted", "mobile"),
                    icon: "delete",
                },
                {
                    id: "task-module-rules-rule-updated",
                    label: this.$t("notification.taskModuleRulesRuleUpdatedNotification"),
                    web: this.isActive("task-module-rules-rule-updated", "web"),
                    email: this.isActive("task-module-rules-rule-updated", "email"),
                    mobile: this.isActive("task-module-rules-rule-updated", "mobile"),
                    icon: "edit",
                },
                {
                    id: "task-module-rules-rule-enabled",
                    label: this.$t("notification.taskModuleRulesRuleEnabledNotification"),
                    web: this.isActive("task-module-rules-rule-enabled", "web"),
                    email: this.isActive("task-module-rules-rule-enabled", "email"),
                    mobile: this.isActive("task-module-rules-rule-enabled", "mobile"),
                    icon: "check_circle",
                },
                {
                    id: "task-module-rules-rule-disabled",
                    label: this.$t("notification.taskModuleRulesRuleDisabledNotification"),
                    web: this.isActive("task-module-rules-rule-disabled", "web"),
                    email: this.isActive("task-module-rules-rule-disabled", "email"),
                    mobile: this.isActive("task-module-rules-rule-disabled", "mobile"),
                    icon: "cancel",
                },
                {
                    id: "drive-folder-created",
                    label: this.$t("notification.driveFolderCreatedNotification"),
                    web: this.isActive("drive-folder-created", "web"),
                    email: this.isActive("drive-folder-created", "email"),
                    mobile: this.isActive("drive-folder-created", "mobile"),
                    icon: "create_new_folder",
                },
                {
                    id: "drive-folder-deleted",
                    label: this.$t("notification.driveFolderDeletedNotification"),
                    web: this.isActive("drive-folder-deleted", "web"),
                    email: this.isActive("drive-folder-deleted", "email"),
                    mobile: this.isActive("drive-folder-deleted", "mobile"),
                    icon: "folder_delete",
                },
                {
                    id: "drive-folder-renamed",
                    label: this.$t("notification.driveFolderRenamedNotification"),
                    web: this.isActive("drive-folder-renamed", "web"),
                    email: this.isActive("drive-folder-renamed", "email"),
                    mobile: this.isActive("drive-folder-renamed", "mobile"),
                    icon: "drive_file_rename_outline",
                },
                {
                    id: "drive-file-added",
                    label: this.$t("notification.driveFileAddedNotification"),
                    web: this.isActive("drive-file-added", "web"),
                    email: this.isActive("drive-file-added", "email"),
                    mobile: this.isActive("drive-file-added", "mobile"),
                    icon: "note_add",
                },
                {
                    id: "drive-file-deleted",
                    label: this.$t("notification.driveFileDeletedNotification"),
                    web: this.isActive("drive-file-deleted", "web"),
                    email: this.isActive("drive-file-deleted", "email"),
                    mobile: this.isActive("drive-file-deleted", "mobile"),
                    icon: "delete_outline",
                },
                {
                    id: "contact-module-rules-enabled",
                    label: this.$t("notification.contactModuleRulesEnabledNotification"),
                    web: this.isActive("contact-module-rules-enabled", "web"),
                    email: this.isActive("contact-module-rules-enabled", "email"),
                    mobile: this.isActive("contact-module-rules-enabled", "mobile"),
                    icon: "check_circle",
                },
                {
                    id: "contact-module-rules-disabled",
                    label: this.$t("notification.contactModuleRulesDisabledNotification"),
                    web: this.isActive("contact-module-rules-disabled", "web"),
                    email: this.isActive("contact-module-rules-disabled", "email"),
                    mobile: this.isActive("contact-module-rules-disabled", "mobile"),
                    icon: "cancel",
                },
                {
                    id: "contact-module-rules-rule-added",
                    label: this.$t("notification.contactModuleRulesRuleAddedNotification"),
                    web: this.isActive("contact-module-rules-rule-added", "web"),
                    email: this.isActive("contact-module-rules-rule-added", "email"),
                    mobile: this.isActive("contact-module-rules-rule-added", "mobile"),
                    icon: "add_circle",
                },
                {
                    id: "contact-module-rules-rule-updated",
                    label: this.$t("notification.contactModuleRulesRuleUpdatedNotification"),
                    web: this.isActive("contact-module-rules-rule-updated", "web"),
                    email: this.isActive("contact-module-rules-rule-updated", "email"),
                    mobile: this.isActive("contact-module-rules-rule-updated", "mobile"),
                    icon: "edit",
                },
                {
                    id: "contact-module-rules-rule-deleted",
                    label: this.$t("notification.contactModuleRulesRuleDeletedNotification"),
                    web: this.isActive("contact-module-rules-rule-deleted", "web"),
                    email: this.isActive("contact-module-rules-rule-deleted", "email"),
                    mobile: this.isActive("contact-module-rules-rule-deleted", "mobile"),
                    icon: "delete",
                },
                {
                    id: "contact-module-rules-rule-enabled",
                    label: this.$t("notification.contactModuleRulesRuleEnabledNotification"),
                    web: this.isActive("contact-module-rules-rule-enabled", "web"),
                    email: this.isActive("contact-module-rules-rule-enabled", "email"),
                    mobile: this.isActive("contact-module-rules-rule-enabled", "mobile"),
                    icon: "check_circle",
                },
                {
                    id: "contact-module-rules-rule-disabled",
                    label: this.$t("notification.contactModuleRulesRuleDisabledNotification"),
                    web: this.isActive("contact-module-rules-rule-disabled", "web"),
                    email: this.isActive("contact-module-rules-rule-disabled", "email"),
                    mobile: this.isActive("contact-module-rules-rule-disabled", "mobile"),
                    icon: "cancel",
                },
                {
                    id: "developer-token-changed",
                    label: this.$t("notification.developerTokenChangedNotification"),
                    web: this.isActive("developer-token-changed", "web"),
                    email: this.isActive("developer-token-changed", "email"),
                    mobile: this.isActive("developer-token-changed", "mobile"),
                    icon: "vpn_key",
                },
                {
                    id: "contact-batch-updated",
                    label: this.$t("notification.contactBatchUpdatedNotification"),
                    web: this.isActive("contact-batch-updated", "web"),
                    email: this.isActive("contact-batch-updated", "email"),
                    mobile: this.isActive("contact-batch-updated", "mobile"),
                    icon: "group",
                },
                {
                    id: "chat-data-downloaded",
                    label: this.$t("notification.chatDataDownloadedNotification"),
                    web: this.isActive("chat-data-downloaded", "web"),
                    email: this.isActive("chat-data-downloaded", "email"),
                    mobile: this.isActive("chat-data-downloaded", "mobile"),
                    icon: "download",
                },
                {
                    id: "table-created",
                    label: this.$t("notification.tableCreatedNotification"),
                    web: this.isActive("table-created", "web"),
                    email: this.isActive("table-created", "email"),
                    mobile: this.isActive("table-created", "mobile"),
                    icon: "table_chart",
                },
                {
                    id: "table-deleted",
                    label: this.$t("notification.tableDeletedNotification"),
                    web: this.isActive("table-deleted", "web"),
                    email: this.isActive("table-deleted", "email"),
                    mobile: this.isActive("table-deleted", "mobile"),
                    icon: "delete",
                },
                {
                    id: "table-restored",
                    label: this.$t("notification.tableRestoredNotification"),
                    web: this.isActive("table-restored", "web"),
                    email: this.isActive("table-restored", "email"),
                    mobile: this.isActive("table-restored", "mobile"),
                    icon: "restore",
                },
                {
                    id: "table-permanently-deleted",
                    label: this.$t("notification.tablePermanentlyDeletedNotification"),
                    web: this.isActive("table-permanently-deleted", "web"),
                    email: this.isActive("table-permanently-deleted", "email"),
                    mobile: this.isActive("table-permanently-deleted", "mobile"),
                    icon: "delete_forever",
                },
                {
                    id: "table-field-added",
                    label: this.$t("notification.tableFieldAddedNotification"),
                    web: this.isActive("table-field-added", "web"),
                    email: this.isActive("table-field-added", "email"),
                    mobile: this.isActive("table-field-added", "mobile"),
                    icon: "add_box",
                },
                {
                    id: "table-field-updated",
                    label: this.$t("notification.tableFieldUpdatedNotification"),
                    web: this.isActive("table-field-updated", "web"),
                    email: this.isActive("table-field-updated", "email"),
                    mobile: this.isActive("table-field-updated", "mobile"),
                    icon: "edit",
                },
                {
                    id: "table-field-deleted",
                    label: this.$t("notification.tableFieldDeletedNotification"),
                    web: this.isActive("table-field-deleted", "web"),
                    email: this.isActive("table-field-deleted", "email"),
                    mobile: this.isActive("table-field-deleted", "mobile"),
                    icon: "delete",
                },
                {
                    id: "table-view-actions",
                    label: this.$t("notification.tableViewActionsNotification"),
                    web: this.isActive("table-view-actions", "web"),
                    email: this.isActive("table-view-actions", "email"),
                    mobile: this.isActive("table-view-actions", "mobile"),
                    icon: "visibility",
                },
                {
                    id: "table-page-actions",
                    label: this.$t("notification.tablePageActionsNotification"),
                    web: this.isActive("table-page-actions", "web"),
                    email: this.isActive("table-page-actions", "email"),
                    mobile: this.isActive("table-page-actions", "mobile"),
                    icon: "note_add",
                },
                {
                    id: "table-widget-actions",
                    label: this.$t("notification.tableWidgetActionsNotification"),
                    web: this.isActive("table-widget-actions", "web"),
                    email: this.isActive("table-widget-actions", "email"),
                    mobile: this.isActive("table-widget-actions", "mobile"),
                    icon: "widgets",
                },
                {
                    id: "table-permission-changed",
                    label: this.$t("notification.tablePermissionChangedNotification"),
                    web: this.isActive("table-permission-changed", "web"),
                    email: this.isActive("table-permission-changed", "email"),
                    mobile: this.isActive("table-permission-changed", "mobile"),
                    icon: "lock",
                },
                {
                    id: "table-data-downloaded",
                    label: this.$t("notification.tableDataDownloadedNotification"),
                    web: this.isActive("table-data-downloaded", "web"),
                    email: this.isActive("table-data-downloaded", "email"),
                    mobile: this.isActive("table-data-downloaded", "mobile"),
                    icon: "download",
                },
                {
                    id: "table-data-imported",
                    label: this.$t("notification.tableDataImportedNotification"),
                    web: this.isActive("table-data-imported", "web"),
                    email: this.isActive("table-data-imported", "email"),
                    mobile: this.isActive("table-data-imported", "mobile"),
                    icon: "cloud_upload",
                },
                {
                    id: "table-data-batch-updated",
                    label: this.$t("notification.tableDataBatchUpdatedNotification"),
                    web: this.isActive("table-data-batch-updated", "web"),
                    email: this.isActive("table-data-batch-updated", "email"),
                    mobile: this.isActive("table-data-batch-updated", "mobile"),
                    icon: "update",
                },
                {
                    id: "table-data-batch-deleted",
                    label: this.$t("notification.tableDataBatchDeletedNotification"),
                    web: this.isActive("table-data-batch-deleted", "web"),
                    email: this.isActive("table-data-batch-deleted", "email"),
                    mobile: this.isActive("table-data-batch-deleted", "mobile"),
                    icon: "delete_sweep",
                },
                {
                    id: "task-workflow-crud",
                    // label: this.$t('notification.taskWorkflowCrud'),
                    label: this.$t("notification.workflowDeleted"),
                    web: this.isActive("task-workflow-crud", "web"),
                    email: this.isActive("task-workflow-crud", "email"),
                    mobile: this.isActive("task-workflow-crud", "mobile"),
                    icon: "backspace",
                },
                {
                    id: "task-created",
                    label: this.$t("notification.createdTask"),
                    web: this.isActive("task-created", "web"),
                    email: this.isActive("task-created", "email"),
                    mobile: this.isActive("task-created", "mobile"),
                    icon: "task",
                },
                {
                    id: "task-crud",
                    label: this.$t("notification.taskStatusChanged"),
                    web: this.isActive("task-crud", "web"),
                    email: this.isActive("task-crud", "email"),
                    mobile: this.isActive("task-crud", "mobile"),
                    icon: "task",
                },
                {
                    id: "task-deleted",
                    label: this.$t("notification.deletedTask"),
                    web: this.isActive("task-deleted", "web"),
                    email: this.isActive("task-deleted", "email"),
                    mobile: this.isActive("task-deleted", "mobile"),
                    icon: "backspace",
                },
                {
                    id: "system-status",
                    label: this.$t("notification.systemStatus"),
                    web: this.isActive("system-status", "web"),
                    email: this.isActive("system-status", "email"),
                    mobile: this.isActive("system-status", "mobile"),
                    icon: "support_agent",
                },
                {
                    id: "chatbot-story-crud",
                    label: this.$t("notification.chatbotStoryCrud"),
                    web: this.isActive("chatbot-story-crud", "web"),
                    email: this.isActive("chatbot-story-crud", "email"),
                    mobile: this.isActive("chatbot-story-crud", "mobile"),
                    icon: "smart_toy",
                },
                {
                    id: "chatbot-forward-chat",
                    label: this.$t("notification.chatbotForwardAgent"),
                    web: this.isActive("chatbot-forward-chat", "web"),
                    email: this.isActive("chatbot-forward-chat", "email"),
                    mobile: this.isActive("chatbot-forward-chat", "mobile"),
                    icon: "forward_to_inbox",
                },
                {
                    id: "chatbot-user-segment-crud",
                    label: this.$t("notification.userSegmentCrud"),
                    web: this.isActive("chatbot-user-segment-crud", "web"),
                    email: this.isActive("chatbot-user-segment-crud", "email"),
                    mobile: this.isActive("chatbot-user-segment-crud", "mobile"),
                    icon: "group_add",
                },
                {
                    id: "chatbot-credit-low",
                    label: this.$t("notification.chatbotCreditLow"),
                    web: this.isActive("chatbot-credit-low", "web"),
                    email: this.isActive("chatbot-credit-low", "email"),
                    mobile: this.isActive("chatbot-credit-low", "mobile"),
                    icon: "money_off",
                },
                {
                    id: "chatbot-ai-model-updated",
                    label: this.$t("notification.chatbotAiModelUpdatedSetting"),
                    web: this.isActive("chatbot-ai-model-updated", "web"),
                    email: this.isActive("chatbot-ai-model-updated", "email"),
                    mobile: this.isActive("chatbot-ai-model-updated", "mobile"),
                    icon: "model_training",
                },
                {
                    id: "whatsapp-credit-low",
                    label: this.$t("notification.wpCreditLow"),
                    web: this.isActive("whatsapp-credit-low", "web"),
                    email: this.isActive("whatsapp-credit-low", "email"),
                    mobile: this.isActive("whatsapp-credit-low", "mobile"),
                    icon: "money_off",
                },
                {
                    id: "whatsapp-customer-group-crud",
                    label: this.$t("notification.wpCustomerGroupCrud"),
                    web: this.isActive("whatsapp-customer-group-crud", "web"),
                    email: this.isActive("whatsapp-customer-group-crud", "email"),
                    mobile: this.isActive("whatsapp-customer-group-crud", "mobile"),
                    icon: "group_add",
                },
                {
                    id: "whatsapp-broadcast-message-crud",
                    label: this.$t("notification.wpBroadcastMessageStatus"),
                    web: this.isActive("whatsapp-broadcast-message-crud", "web"),
                    email: this.isActive("whatsapp-broadcast-message-crud", "email"),
                    mobile: this.isActive("whatsapp-broadcast-message-crud", "mobile"),
                    icon: "campaign",
                },
                {
                    id: "whatsapp-template-message-crud",
                    label: this.$t("notification.wpTemplateMesssageCrud"),
                    web: this.isActive("whatsapp-template-message-crud", "web"),
                    email: this.isActive("whatsapp-template-message-crud", "email"),
                    mobile: this.isActive("whatsapp-template-message-crud", "mobile"),
                    icon: "add_comment",
                },
                {
                    id: "whatsapp-qr-code-status",
                    label: this.$t("notification.whatsappQrChannelStatusUpdated"),
                    web: this.isActive("whatsapp-qr-code-status", "web"),
                    email: this.isActive("whatsapp-qr-code-status", "email"),
                    mobile: this.isActive("whatsapp-qr-code-status", "mobile"),
                    icon: "qr_code_scanner",
                },
                {
                    id: "waba-supsis-partner-remove",
                    label: this.$t("notification.wabaSupsisPartnerRemove"),
                    web: this.isActive("waba-supsis-partner-remove", "web"),
                    email: this.isActive("waba-supsis-partner-remove", "email"),
                    mobile: this.isActive("waba-supsis-partner-remove", "mobile"),
                    icon: "link_off",
                },
                {
                    id: "waba-supsis-partner-added",
                    label: this.$t("notification.wabaSupsisPartnerAdded"),
                    web: this.isActive("waba-supsis-partner-added", "web"),
                    email: this.isActive("waba-supsis-partner-added", "email"),
                    mobile: this.isActive("waba-supsis-partner-added", "mobile"),
                    icon: "person_add",
                },
                {
                    id: "waba-supsis-account-deleted",
                    label: this.$t("notification.wabaSupsisAccountDeleted"),
                    web: this.isActive("waba-supsis-account-deleted", "web"),
                    email: this.isActive("waba-supsis-account-deleted", "email"),
                    mobile: this.isActive("waba-supsis-account-deleted", "mobile"),
                    icon: "delete_forever",
                },
                {
                    id: "waba-supsis-account-violation",
                    label: this.$t("notification.wabaSupsisAccountViolation"),
                    web: this.isActive("waba-supsis-account-violation", "web"),
                    email: this.isActive("waba-supsis-account-violation", "email"),
                    mobile: this.isActive("waba-supsis-account-violation", "mobile"),
                    icon: "warning",
                },
                {
                    id: "waba-supsis-ad-account-linked",
                    label: this.$t("notification.wabaSupsisAdAccountLinked"),
                    web: this.isActive("waba-supsis-ad-account-linked", "web"),
                    email: this.isActive("waba-supsis-ad-account-linked", "email"),
                    mobile: this.isActive("waba-supsis-ad-account-linked", "mobile"),
                    icon: "link",
                },
                {
                    id: "waba-supsis-auth-intl-price-eligibility-update",
                    label: this.$t("notification.wabaSupsisAuthIntlPriceEligibilityUpdate"),
                    web: this.isActive("waba-supsis-auth-intl-price-eligibility-update", "web"),
                    email: this.isActive("waba-supsis-auth-intl-price-eligibility-update", "email"),
                    mobile: this.isActive("waba-supsis-auth-intl-price-eligibility-update", "mobile"),
                    icon: "price_change",
                },
                {
                    id: "waba-supsis-disabled-update",
                    label: this.$t("notification.wabaSupsisDisabledUpdate"),
                    web: this.isActive("waba-supsis-disabled-update", "web"),
                    email: this.isActive("waba-supsis-disabled-update", "email"),
                    mobile: this.isActive("waba-supsis-disabled-update", "mobile"),
                    icon: "block",
                },
                {
                    id: "waba-supsis-mm-lite-terms-signed",
                    label: this.$t("notification.wabaSupsisMmLiteTermsSigned"),
                    web: this.isActive("waba-supsis-mm-lite-terms-signed", "web"),
                    email: this.isActive("waba-supsis-mm-lite-terms-signed", "email"),
                    mobile: this.isActive("waba-supsis-mm-lite-terms-signed", "mobile"),
                    icon: "fact_check",
                },
                {
                    id: "waba-supsis-partner-app-installed",
                    label: this.$t("notification.wabaSupsisPartnerAppInstalled"),
                    web: this.isActive("waba-supsis-partner-app-installed", "web"),
                    email: this.isActive("waba-supsis-partner-app-installed", "email"),
                    mobile: this.isActive("waba-supsis-partner-app-installed", "mobile"),
                    icon: "install_mobile",
                },
                {
                    id: "waba-supsis-partner-app-uninstalled",
                    label: this.$t("notification.wabaSupsisPartnerAppUninstalled"),
                    web: this.isActive("waba-supsis-partner-app-uninstalled", "web"),
                    email: this.isActive("waba-supsis-partner-app-uninstalled", "email"),
                    mobile: this.isActive("waba-supsis-partner-app-uninstalled", "mobile"),
                    icon: "delete_forever",
                },
                {
                    id: "waba-supsis-partner-client-certification-status-update",
                    label: this.$t("notification.wabaSupsisPartnerClientCertificationStatusUpdate"),
                    web: this.isActive("waba-supsis-partner-client-certification-status-update", "web"),
                    email: this.isActive("waba-supsis-partner-client-certification-status-update", "email"),
                    mobile: this.isActive("waba-supsis-partner-client-certification-status-update", "mobile"),
                    icon: "verified_user",
                },
                {
                    id: "waba-supsis-business-primary-location-country-update",
                    label: this.$t("notification.wabaSupsisBusinessPrimaryLocationCountryUpdate"),
                    web: this.isActive("waba-supsis-business-primary-location-country-update", "web"),
                    email: this.isActive("waba-supsis-business-primary-location-country-update", "email"),
                    mobile: this.isActive("waba-supsis-business-primary-location-country-update", "mobile"),
                    icon: "public",
                },
                {
                    id: "waba-supsis-volume-based-pricing-tier-update",
                    label: this.$t("notification.wabaSupsisVolumeBasedPricingTierUpdate"),
                    web: this.isActive("waba-supsis-volume-based-pricing-tier-update", "web"),
                    email: this.isActive("waba-supsis-volume-based-pricing-tier-update", "email"),
                    mobile: this.isActive("waba-supsis-volume-based-pricing-tier-update", "mobile"),
                    icon: "trending_up",
                },
                {
                    id: "waba-supsis-message-template-components-update",
                    label: this.$t("notification.wabaSupsisMessageTemplateComponentsUpdate"),
                    web: this.isActive("waba-supsis-message-template-components-update", "web"),
                    email: this.isActive("waba-supsis-message-template-components-update", "email"),
                    mobile: this.isActive("waba-supsis-message-template-components-update", "mobile"),
                    icon: "article",
                },
                {
                    id: "waba-supsis-message-template-status-update",
                    label: this.$t("notification.wabaSupsisMessageTemplateStatusUpdate"),
                    web: this.isActive("waba-supsis-message-template-status-update", "web"),
                    email: this.isActive("waba-supsis-message-template-status-update", "email"),
                    mobile: this.isActive("waba-supsis-message-template-status-update", "mobile"),
                    icon: "speed",
                },
                {
                    id: "waba-supsis-template-category-update",
                    label: this.$t("notification.wabaSupsisTemplateCategoryUpdate"),
                    web: this.isActive("waba-supsis-template-category-update", "web"),
                    email: this.isActive("waba-supsis-template-category-update", "email"),
                    mobile: this.isActive("waba-supsis-template-category-update", "mobile"),
                    icon: "category",
                },
                {
                    id: "reservation-events",
                    label: this.$t("notification.reservationMessageCrud"),
                    web: this.isActive("reservation-events", "web"),
                    email: this.isActive("reservation-events", "email"),
                    mobile: this.isActive("reservation-events", "mobile"),
                    icon: "today",
                },
                {
                    id: "white-list-events",
                    label: this.$t("notification.ipAddressWhiteListEvents"),
                    web: this.isActive("white-list-events", "web"),
                    email: this.isActive("white-list-events", "email"),
                    mobile: this.isActive("white-list-events", "mobile"),
                    icon: "today",
                },
                {
                    id: "auto-rebalance-events",
                    label: this.$t("notification.autoRebalanceEvents"),
                    web: this.isActive("auto-rebalance-events", "web"),
                    email: this.isActive("auto-rebalance-events", "email"),
                    mobile: this.isActive("auto-rebalance-events", "mobile"),
                    icon: "money_off",
                },
                {
                    id: "automation-created",
                    label: this.$t("notification.automationCreatedNotification"),
                    web: this.isActive("automation-created", "web"),
                    email: this.isActive("automation-created", "email"),
                    mobile: this.isActive("automation-created", "mobile"),
                    icon: "rocket_launch",
                },
                {
                    id: "automation-deleted",
                    label: this.$t("notification.automationDeletedNotification"),
                    web: this.isActive("automation-deleted", "web"),
                    email: this.isActive("automation-deleted", "email"),
                    mobile: this.isActive("automation-deleted", "mobile"),
                    icon: "delete",
                },
                {
                    id: "automation-published",
                    label: this.$t("notification.automationPublishedNotification"),
                    web: this.isActive("automation-published", "web"),
                    email: this.isActive("automation-published", "email"),
                    mobile: this.isActive("automation-published", "mobile"),
                    icon: "publish",
                },
                {
                    id: "automation-unpublished",
                    label: this.$t("notification.automationUnpublishedNotification"),
                    web: this.isActive("automation-unpublished", "web"),
                    email: this.isActive("automation-unpublished", "email"),
                    mobile: this.isActive("automation-unpublished", "mobile"),
                    icon: "unpublished",
                },
                {
                    id: "automation-updated",
                    label: this.$t("notification.automationUpdatedNotification"),
                    web: this.isActive("automation-updated", "web"),
                    email: this.isActive("automation-updated", "email"),
                    mobile: this.isActive("automation-updated", "mobile"),
                    icon: "edit",
                },
                {
                    id: "automation-task-credit-low",
                    label: this.$t("auto.automationTaskCreditLow"),
                    web: this.isActive("automation-task-credit-low", "web"),
                    email: this.isActive("automation-task-credit-low", "email"),
                    mobile: this.isActive("automation-task-credit-low", "mobile"),
                    icon: "warning",
                },
                {
                    id: "automation-task-credit-done",
                    label: this.$t("auto.automationTaskCreditDone"),
                    web: this.isActive("automation-task-credit-done", "web"),
                    email: this.isActive("automation-task-credit-done", "email"),
                    mobile: this.isActive("automation-task-credit-done", "mobile"),
                    icon: "error",
                },
                {
                    id: "form-created-scope",
                    label: this.$t("notification.formCreatedNotification"),
                    web: this.isActive("form-created-scope", "web"),
                    email: this.isActive("form-created-scope", "email"),
                    mobile: this.isActive("form-created-scope", "mobile"),
                    icon: "add_box",
                },
                {
                    id: "form-updated-scope",
                    label: this.$t("notification.formUpdatedNotification"),
                    web: this.isActive("form-updated-scope", "web"),
                    email: this.isActive("form-updated-scope", "email"),
                    mobile: this.isActive("form-updated-scope", "mobile"),
                    icon: "edit",
                },
                {
                    id: "form-deleted",
                    label: this.$t("notification.formDeletedNotification"),
                    web: this.isActive("form-deleted", "web"),
                    email: this.isActive("form-deleted", "email"),
                    mobile: this.isActive("form-deleted", "mobile"),
                    icon: "delete",
                },
                {
                    id: "form-downloaded-scope",
                    label: this.$t("notification.formDownloadedNotification"),
                    web: this.isActive("form-downloaded-scope", "web"),
                    email: this.isActive("form-downloaded-scope", "email"),
                    mobile: this.isActive("form-downloaded-scope", "mobile"),
                    icon: "download",
                },
                {
                    id: "form-view-limit-low",
                    label: this.$t("notification.formViewLimitLow"),
                    web: this.isActive("form-view-limit-low", "web"),
                    email: this.isActive("form-view-limit-low", "email"),
                    mobile: this.isActive("form-view-limit-low", "mobile"),
                    icon: "warning",
                },
                {
                    id: "form-view-limit-done",
                    label: this.$t("notification.formViewLimitDone"),
                    web: this.isActive("form-view-limit-done", "web"),
                    email: this.isActive("form-view-limit-done", "email"),
                    mobile: this.isActive("form-view-limit-done", "mobile"),
                    icon: "error",
                },
                {
                    id: "user-info-changed-scope",
                    label: this.$t("notification.userInfoActions"),
                    web: this.isActive("user-info-changed-scope", "web"),
                    email: this.isActive("user-info-changed-scope", "email"),
                    mobile: this.isActive("user-info-changed-scope", "mobile"),
                    icon: "admin_panel_settings",
                },
                {
                    id: "role-updated",
                    label: this.$t("notification.roleUpdatedNotification"),
                    web: this.isActive("role-updated", "web"),
                    email: this.isActive("role-updated", "email"),
                    mobile: this.isActive("role-updated", "mobile"),
                    icon: "manage_accounts",
                },
                {
                    id: "web-app-created",
                    label: this.$t("notification.webAppCreatedNotification"),
                    web: this.isActive("web-app-created", "web"),
                    email: this.isActive("web-app-created", "email"),
                    mobile: this.isActive("web-app-created", "mobile"),
                    icon: "web",
                },
                {
                    id: "web-app-updated",
                    label: this.$t("notification.webAppUpdatedNotification"),
                    web: this.isActive("web-app-updated", "web"),
                    email: this.isActive("web-app-updated", "email"),
                    mobile: this.isActive("web-app-updated", "mobile"),
                    icon: "edit",
                },
                {
                    id: "web-app-deleted",
                    label: this.$t("notification.webAppDeletedNotification"),
                    web: this.isActive("web-app-deleted", "web"),
                    email: this.isActive("web-app-deleted", "email"),
                    mobile: this.isActive("web-app-deleted", "mobile"),
                    icon: "delete",
                },
                {
                    id: "web-tab-created",
                    label: this.$t("notification.webTabCreatedNotification"),
                    web: this.isActive("web-tab-created", "web"),
                    email: this.isActive("web-tab-created", "email"),
                    mobile: this.isActive("web-tab-created", "mobile"),
                    icon: "tab",
                },
                {
                    id: "web-tab-updated",
                    label: this.$t("notification.webTabUpdatedNotification"),
                    web: this.isActive("web-tab-updated", "web"),
                    email: this.isActive("web-tab-updated", "email"),
                    mobile: this.isActive("web-tab-updated", "mobile"),
                    icon: "edit",
                },
                {
                    id: "web-tab-deleted",
                    label: this.$t("notification.webTabDeletedNotification"),
                    web: this.isActive("web-tab-deleted", "web"),
                    email: this.isActive("web-tab-deleted", "email"),
                    mobile: this.isActive("web-tab-deleted", "mobile"),
                    icon: "delete",
                },
                {
                    id: "module-created",
                    label: this.$t("notification.moduleCreatedNotification"),
                    web: this.isActive("module-created", "web"),
                    email: this.isActive("module-created", "email"),
                    mobile: this.isActive("module-created", "mobile"),
                    icon: "add_box",
                },
                {
                    id: "module-updated",
                    label: this.$t("notification.moduleUpdatedNotification"),
                    web: this.isActive("module-updated", "web"),
                    email: this.isActive("module-updated", "email"),
                    mobile: this.isActive("module-updated", "mobile"),
                    icon: "edit",
                },
                {
                    id: "module-deleted",
                    label: this.$t("notification.moduleDeletedNotification"),
                    web: this.isActive("module-deleted", "web"),
                    email: this.isActive("module-deleted", "email"),
                    mobile: this.isActive("module-deleted", "mobile"),
                    icon: "delete",
                },
                {
                    id: "relation-created",
                    label: this.$t("notification.relationCreatedNotification"),
                    web: this.isActive("relation-created", "web"),
                    email: this.isActive("relation-created", "email"),
                    mobile: this.isActive("relation-created", "mobile"),
                    icon: "link",
                },
                {
                    id: "relation-updated",
                    label: this.$t("notification.relationUpdatedNotification"),
                    web: this.isActive("relation-updated", "web"),
                    email: this.isActive("relation-updated", "email"),
                    mobile: this.isActive("relation-updated", "mobile"),
                    icon: "edit",
                },
                {
                    id: "voice-agent-created",
                    label: this.$t("notification.voiceAgentCreatedNotification"),
                    web: this.isActive("voice-agent-created", "web"),
                    email: this.isActive("voice-agent-created", "email"),
                    mobile: this.isActive("voice-agent-created", "mobile"),
                    icon: "record_voice_over",
                },
                {
                    id: "voice-agent-updated",
                    label: this.$t("notification.voiceAgentUpdatedNotification"),
                    web: this.isActive("voice-agent-updated", "web"),
                    email: this.isActive("voice-agent-updated", "email"),
                    mobile: this.isActive("voice-agent-updated", "mobile"),
                    icon: "record_voice_over",
                },
                {
                    id: "voice-agent-deleted",
                    label: this.$t("notification.voiceAgentDeletedNotification"),
                    web: this.isActive("voice-agent-deleted", "web"),
                    email: this.isActive("voice-agent-deleted", "email"),
                    mobile: this.isActive("voice-agent-deleted", "mobile"),
                    icon: "record_voice_over",
                },
                {
                    id: "voice-agent-phone-number-inbound-agent-changed",
                    label: this.$t("notification.voiceAgentPhoneNumberInboundAgentChangedNotification"),
                    web: this.isActive("voice-agent-phone-number-inbound-agent-changed", "web"),
                    email: this.isActive("voice-agent-phone-number-inbound-agent-changed", "email"),
                    mobile: this.isActive("voice-agent-phone-number-inbound-agent-changed", "mobile"),
                    icon: "phone",
                },
                {
                    id: "voice-agent-phone-number-outbound-agent-changed",
                    label: this.$t("notification.voiceAgentPhoneNumberOutboundAgentChangedNotification"),
                    web: this.isActive("voice-agent-phone-number-outbound-agent-changed", "web"),
                    email: this.isActive("voice-agent-phone-number-outbound-agent-changed", "email"),
                    mobile: this.isActive("voice-agent-phone-number-outbound-agent-changed", "mobile"),
                    icon: "phone",
                },
                {
                    id: "voice-agent-batch-call-created",
                    label: this.$t("notification.voiceAgentBatchCallCreatedNotification"),
                    web: this.isActive("voice-agent-batch-call-created", "web"),
                    email: this.isActive("voice-agent-batch-call-created", "email"),
                    mobile: this.isActive("voice-agent-batch-call-created", "mobile"),
                    icon: "call",
                },
                {
                    id: "voice-agent-knowledge-base-created",
                    label: this.$t("notification.voiceAgentKnowledgeBaseCreatedNotification"),
                    web: this.isActive("voice-agent-knowledge-base-created", "web"),
                    email: this.isActive("voice-agent-knowledge-base-created", "email"),
                    mobile: this.isActive("voice-agent-knowledge-base-created", "mobile"),
                    icon: "library_books",
                },
                {
                    id: "voice-agent-knowledge-base-deleted",
                    label: this.$t("notification.voiceAgentKnowledgeBaseDeletedNotification"),
                    web: this.isActive("voice-agent-knowledge-base-deleted", "web"),
                    email: this.isActive("voice-agent-knowledge-base-deleted", "email"),
                    mobile: this.isActive("voice-agent-knowledge-base-deleted", "mobile"),
                    icon: "library_books",
                },
            ].filter((row) => this.allowedScopes.includes(row.id));
        },
    },
    methods: {
        hoverEffect(e, hover) {
            e.target.classList[hover ? "add" : "remove"]("active");
        },
        getScopeSettings() {
            return this.settings.filter((setting) => this.allowedScopes.includes(setting.scope));
        },
        isActive(scope, platform) {
            const setting = this.getScopeSettings().find((setting) => setting.scope === scope);
            if (!setting) {
                return false;
            } else {
                return setting[platform];
            }
        },
        toggleActive(item, platform) {
            const status = this.isActive(item, platform);
            this.loading = {
                platform,
                item,
            };
            setTimeout(() => {
                ACTIVITY_API.NOTIFICATION.updateSingleSetting(platform, item, !status).then(() => {
                    this.$emit("update", item, platform, !status);
                    this.loading = null;
                });
            }, 100);
        },
    },
});
</script>

<style scoped lang="scss">
.scopes-table {
    width: 100%;
    .spin-effect {
        color: rgb(62, 62, 213);
        animation: spinEffect 1s infinite;
    }

    @keyframes spinEffect {
        0% {
            transform: rotate(365deg);
        }
        100% {
            transform: rotate(0deg);
        }
    }

    .scopes-table-header {
        display: flex;
        align-items: center;
        width: 100%;
        padding: 10px;

        .scopes-table-header-item {
            flex: 1;
            text-transform: none;
            font-size: 14px;
            font-weight: 700;
            color: var(--color-text-strong-default);

            &.center {
                justify-content: center;
                display: flex;
            }
        }
    }

    .scopes-table-body {
        display: flex;
        flex-direction: column;
        //gap: 10px;
        width: 100%;
        align-items: center;
        overflow-y: auto;
        height: 100%;
        max-height: calc(100vh - 100px);

        .row:nth-child(odd) {
            background: var(--color-bg-neutral-default);
        }

        .row {
            display: flex;
            align-items: center;
            gap: 20px 10px;
            width: 100%;

            background: var(--color-bg-default);
            cursor: pointer;

            &:hover {
                opacity: 0.8;
            }

            .cell {
                flex: 1;
                font-size: 14px;
                font-weight: 400;
                color: var(--color-text-default);
                line-height: 19px;
                overflow: hidden !important;
                text-overflow: ellipsis;
                white-space: nowrap;
                padding: 10px;
                min-height: 50px;
                display: flex;
                align-items: center;

                .disabled-item {
                    :first-child {
                        display: none;
                    }
                    &.active {
                        :first-child {
                            display: block;
                        }
                        :last-child {
                            display: none;
                        }
                    }
                }
                .first-cell {
                    display: flex;
                    align-items: center;
                    gap: 5px;

                    .material-icons {
                        font-size: 18px;
                        color: var(--color-icon-default);
                    }
                }
            }

            .checkbox-cell {
                padding: 0 !important;

                .material-icons {
                    font-size: 20px;
                }

                .supsis-button {
                    min-height: 50px !important;
                    width: 100% !important;
                    max-width: unset !important;
                    border: none !important;
                    background: none !important;

                    &:hover {
                        background: var(--color-bg-primary-subdued-hover) !important;
                    }
                }

                &:hover {
                    .supsis-button {
                        background: var(--color-bg-primary-subdued-hover) !important;
                    }
                }
            }
        }
    }
}
</style>
